module.exports = __webpack_public_path__ + "static/media/receive-error.5976e33a.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/audio/receive-error.ogg
// module id = 395
// module chunks = 0